import { SYSTEM_PAGES } from "./pages"

const ASSET_PATHS: string[] = Object.keys(SYSTEM_PAGES)

export const routing = (route: string, location: string, assetId?: string, back: boolean = false, page?: string) => {
  let path = route
  const endOfPath = location.split("/").pop()

  if (assetId && !back) {
    if (!path.endsWith("/")) path += "/"

    path += `${assetId}`
  }

  if (!back && typeof page !== "string" && endOfPath && ASSET_PATHS.includes(endOfPath)) {
    return path + "/" + endOfPath
  }

  if (page) {
    return path + "/" + page
  }

  return path
}
